// src/pages/investor/investorDashboard.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import auctionService from '../../services/auctionService';
import walletService from '../../services/walletService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/free-solid-svg-icons';


export default function InvestorDashboard() {
  const [stats, setStats] = useState(null);
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const [statsRes, balRes] = await Promise.allSettled([
          auctionService.getInvestorDashboardStats(),
          walletService.getBalance(),
        ]);
        if (!active) return;
        if (statsRes.status === 'fulfilled') setStats(statsRes.value?.data?.data || null);
        if (balRes.status === 'fulfilled') setBalance(balRes.value?.data?.data || null);
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => { active = false; };
  }, []);

  return (
    <DashboardLayout>
      <div style={{ padding: '24px 20px' }}>
        {loading ? <p>Loading stats...</p> : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
            <div className="application-card">
              <h4 style={{ marginTop: 0 }}>Token Holdings</h4>
              <div style={{ fontSize: 28, fontWeight: 700 }}>{stats?.token_holdings_count || 0}</div>
            </div>
            <div className="application-card">
              <h4 style={{ marginTop: 0 }}>Active Sessions</h4>
              <div style={{ fontSize: 28, fontWeight: 700 }}>{stats?.active_sessions_count || 0}</div>
            </div>
            <div className="application-card">
              <h4 style={{ marginTop: 0 }}>Scheduled Sessions</h4>
              <div style={{ fontSize: 28, fontWeight: 700 }}>{stats?.scheduled_sessions_count || 0}</div>
            </div>
            <div className="application-card">
              <h4 style={{ marginTop: 0 }}>Completed Sessions</h4>
              <div style={{ fontSize: 28, fontWeight: 700 }}>{stats?.completed_sessions_count || 0}</div>
            </div>
            {balance && (
              <Link to="/investor/dashboard/wallet" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="application-card" style={{ background: 'linear-gradient(135deg, #1e293b, #334155)', color: '#fff', cursor: 'pointer' }}>
                  <h4 style={{ marginTop: 0, color: '#94a3b8' }}><FontAwesomeIcon icon={faWallet} style={{ marginRight: 6 }} />Wallet</h4>
                  <div style={{ fontSize: 28, fontWeight: 700 }}>
                    ${Number(balance.balance || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                  </div>
                </div>
              </Link>
            )}
          </div>
        )}
      </div>

    </DashboardLayout>

  );
}